//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';

import { gatewayFetch } from '@utils/sessionFetch';
import { createNgApiAdapterService, GetNgApiAdapterType } from 'app/angular-apis/createNgApiAdapter';
import { IGetHashtagsUsageResponse } from './instagramHashtagsUsageApiModels';

const GATEWAY_ENDPOINT = 'instagram_dashboard_gateway';
const INSTAGRAM_HASHTAGS_USAGE_BASE_URL = '/api/v1/hashtags-usage';

/**
 * Retrieve the current usage of hashtags according to the
 * recently searched hashtags Instagram graph API endpoint.
 * /api/v1/hashtags-usage
 *
 * @returns An object with a data array containing all currently used hashtags as a promise
 */
export async function getHashtagsUsage(businessAccountId: string): Promise<IGetHashtagsUsageResponse> {
  const urlWithParams = `${INSTAGRAM_HASHTAGS_USAGE_BASE_URL}?businessAccountId=${businessAccountId}`;

  const res = await gatewayFetch(GATEWAY_ENDPOINT, urlWithParams, {
    method: 'GET',
  });

  return res.json();
}

const instagramHashtagsUsageApi = {
  getHashtagsUsage,
};

const instagramHashtagsUsageApiService = createNgApiAdapterService(instagramHashtagsUsageApi);
export type InstagramHashtagsUsageApiServiceType = GetNgApiAdapterType<typeof instagramHashtagsUsageApiService>;

angular.module('curalate').service('InstagramHashtagsUsageApiService', instagramHashtagsUsageApiService);
